var moduleMap = {
	"./CommunityManagementMFE": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(78), __webpack_require__.e(884), __webpack_require__.e(275), __webpack_require__.e(591), __webpack_require__.e(900)]).then(() => (() => ((__webpack_require__(8900)))));
	},
	"./live": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(78), __webpack_require__.e(688), __webpack_require__.e(353), __webpack_require__.e(359), __webpack_require__.e(884), __webpack_require__.e(275), __webpack_require__.e(591), __webpack_require__.e(165)]).then(() => (() => ((__webpack_require__(1165)))));
	},
	"./ImportHistory": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(78), __webpack_require__.e(336), __webpack_require__.e(688), __webpack_require__.e(653), __webpack_require__.e(784), __webpack_require__.e(411), __webpack_require__.e(884), __webpack_require__.e(275), __webpack_require__.e(591), __webpack_require__.e(144)]).then(() => (() => ((__webpack_require__(6144)))));
	},
	"./ActivateSentryErrorBtn": () => {
		return Promise.all([__webpack_require__.e(884), __webpack_require__.e(93)]).then(() => (() => ((__webpack_require__(93)))));
	},
	"./MembersImport": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(78), __webpack_require__.e(336), __webpack_require__.e(148), __webpack_require__.e(653), __webpack_require__.e(895), __webpack_require__.e(884), __webpack_require__.e(275), __webpack_require__.e(591), __webpack_require__.e(142)]).then(() => (() => ((__webpack_require__(9142)))));
	},
	"./MemberListSearchBar": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(78), __webpack_require__.e(148), __webpack_require__.e(884), __webpack_require__.e(275), __webpack_require__.e(591), __webpack_require__.e(648)]).then(() => (() => ((__webpack_require__(5648)))));
	},
	"./GeneralConfig": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(78), __webpack_require__.e(336), __webpack_require__.e(148), __webpack_require__.e(353), __webpack_require__.e(784), __webpack_require__.e(810), __webpack_require__.e(884), __webpack_require__.e(275), __webpack_require__.e(591), __webpack_require__.e(828)]).then(() => (() => ((__webpack_require__(1530)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});